import React from 'react';
import { Flex, Box, Text } from 'rebass';
import { Formik, FormikConfig } from 'formik';
import * as Yup from 'yup';

import {
  SocialLoginButtons,
  OrDivider,
  SignUpLink,
  FormHeader,
  SmallDivider,
  EmailField,
  PasswordField,
  ButtonLarge,
} from '@mdlinx/component-library';

export const LoginFormContainer = ({
  children,
  onSignUpLinkClicked = () => {},
}: {
  children: React.ReactNode;
  onSignUpLinkClicked?: () => void;
}) => (
  <Flex flexDirection="column">
    <SignUpLink onSignUpLinkClicked={onSignUpLinkClicked} />
    <SmallDivider />
    <FormHeader>Log in</FormHeader>
    <Box mt="12px" />
    {children}
    <OrDivider />
    <SocialLoginButtons />
  </Flex>
);

export interface LoginFormProps {
  onSubmit: FormikConfig<{
    password: string;
    email: string;
    rememberMe: boolean;
  }>['onSubmit'];
  onClickLoginHelp?: () => void;
}

export const LoginForm = ({ onSubmit, onClickLoginHelp }: LoginFormProps) => {
  return (
    <Formik
      initialValues={{ email: '', password: '', rememberMe: true }}
      validationSchema={Yup.object({
        password: Yup.string().required('Required'),
        email: Yup.string()
          .email('Invalid email address')
          .required('Required'),
      })}
      onSubmit={onSubmit}
    >
      {formik => (
        <form onSubmit={formik.handleSubmit}>
          <EmailField onSubmitClicked={() => formik.handleSubmit()} />
          <PasswordField />
          <Flex flexDirection={['column', 'row-reverse']} justifyContent="space-between">
            <Flex justifyContent="flex-end">
              <LoginHelpLink onClick={onClickLoginHelp} />
            </Flex>
            <Box height="15px" />
            <Box width={['100%', '132px']}>
              <ButtonLarge type="submit" disabled={!(formik.dirty && formik.isValid)} isLoading={formik.isSubmitting}>
                Log in
              </ButtonLarge>
            </Box>
          </Flex>
        </form>
      )}
    </Formik>
  );
};

const LoginHelpLink = ({ onClick }: { onClick?: () => void }) => (
  <Box onClick={onClick}>
    <Text
      fontFamily="label"
      fontSize="16px"
      lineHeight={1.38}
      color="blue"
      css={{ textDecoration: 'underline', cursor: 'pointer' }}
    >
      Login Help?
    </Text>
  </Box>
);
